module.exports = __webpack_public_path__ + "img/2.b0a4a5b4.jpg";